var arrowPathTab = 'M36.3536 4.35355C36.5488 4.15829 36.5488 3.8417 36.3536 3.64644L33.1716 0.464462C32.9763 0.2692 32.6597 0.2692 32.4645 0.464462C32.2692 0.659724 32.2692 0.976307 32.4645 1.17157L35.2929 4L32.4645 6.82842C32.2692 7.02369 32.2692 7.34027 32.4645 7.53553C32.6597 7.73079 32.9763 7.73079 33.1716 7.53553L36.3536 4.35355ZM3.08731e-08 4.5L36 4.5L36 3.5L-3.08731e-08 3.5L3.08731e-08 4.5Z';

class ProductsTab extends HTMLElement {
  connectedCallback() {
    if (typeof Splide !== 'undefined') {
      this.init();
    } else {
      window.addEventListener('wnw_load', () => this.init(), { once: true });
    }
  }

  init() {
    this.mounted = new Map();

    const firstActive = this.querySelector('.tab-content.active');
    if (firstActive) this.mountSlider(firstActive);

    const tabs = [...this.querySelectorAll('.tab a')];
    const tabContents = [...this.querySelectorAll('.tab-content')];

    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        tabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');

        tabContents.forEach((c) => c.classList.remove('active'));
        const target = this.querySelector('.tab-content.' + CSS.escape(tab.dataset.target));
        if (!target) return;
        target.classList.add('active');
        this.mountSlider(target);
      });
    });
  }

  mountSlider(content) {
    if (this.mounted.has(content)) return;

    const splideEl = content.querySelector('.splide');
    if (!splideEl) return;

    const splide = new Splide(splideEl, {
      perPage: 4,
      perMove: 1,
      gap: 20,
      pagination: false,
      arrowPath: arrowPathTab,
      breakpoints: {
        989: {
          perPage: 2,
          gap: 10,
          pagination: true,
          arrows: false,
        },
      },
    });

    splide.on('mounted move', () => {
      const numEl = content.querySelector('.num');
      if (!numEl) return;
      numEl.textContent = Math.min(splide.index + splide.options.perPage, splide.length);
    });

    splide.mount();
    this.mounted.set(content, splide);
  }
}

customElements.define('products-tab', ProductsTab);
